export const getFullName = (user: { firstName: string; lastName: string }) => {
  return `${user.firstName} ${user.lastName}`
}
